import { FC, useEffect } from 'react'
import { useAuth } from '../providers/auth'
import LoadingPage from './LoadingPage'

const LogoutPage: FC = () => {
  const { logout } = useAuth()

  useEffect(() => {
    logout()
  }, [])

  return <LoadingPage />
}

export default LogoutPage
